export enum BlockResourceType {
    Projects = 'projects',
    Functions = 'functions',
    Sites = 'sites',
    Databases = 'databases',
    Buckets = 'buckets',
    Providers = 'providers',
    Topics = 'topics',
    Subscribers = 'subscribers',
    Messages = 'messages',
}
